<template>
	<div class="userAgreement">
		<span class="userAgreement-tit">前言</span>
		<div class="txt-box qy">
			<span class="dl">宝莲灯网络科技公司依据以下条件和条款为您提供所享有的服务，请仔细阅读并遵守。
欢迎阅读宝莲灯网络科技有限公司(天信意健险作业端)服务条款协议(下称“本协议”)。本协议阐述之条款和条件适用于您使用天信意健险作业端(所涉域名为：bld888.com)及手机APP客户端天信意健险作业端(安卓系统)和天信意健险作业端(苹果IOS系统)，(以下统称“本网站”)，所提供的在中国境内保险行业查勘理赔员在天信意健险作业端服务平台中开展公估业务服务。</span>
		</div>
		<div class="txt-box" v-for="(text,index) in userAgreementList" :key="index">
			<span class="tit">{{text.title}}</span>
			<span v-for="(text1,index1) in text.text" :key="index1">{{text1}}</span>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				userAgreementList:[
					{
						title: "一、接受条款",
						text: [
							"1.1 本协议内容包括协议正文及所有天信意健险作业端已经发布或将来可能发布的各类规则。所有规则为本协议不可分割的一部分，与本协议正文具有同等法律效力。以任何方式进入天信意健险作业端并使用服务即表示您已充分阅读、理解并同意接受本协议的条款和条件(以下合称“条款”)。",
							"1.2 天信意健险作业端有权根据业务需要酌情修订“条款”，并以本网站公告的形式进行更新，不再单独通知予您。经修订的“条款”一经在天信意健险作业端及/或本网站公布即产生效力。如您不同意相关修订，请您立即停止使用“服务”。如您继续使用“服务”，则将视为您已接受经修订的“条款”，当您与天信意健险作业端发生争议时，应以最新的“条款”为准。"
						]
					},
					{
						title: "二、注册",
						text: [
							"2.1服务使用对象 ",
							"您确认，在您完成注册程序或以其他天信意健险作业端允许的方式实际使用服务时，您应当是具备完全民事权利能力和与所从事的民事行为相适应的行为能力的自然人、法人或其他组织。若您不具备前述主体资格，请勿使用服务，否则您及您的监护人应承担因此而导致的一切后果，且天信意健险作业端有权注销(永久冻结)您的账户，并向您及您的监护人索偿。如您代表一家公司或其他法律主体在天信意健险作业端登记，则您声明和保证，您有权使该公司或该法律主体受本协议“条款”的约束。",
							"2.2注册账户 ",
							"(1)在您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，或在您按照激活页面提示填写信息、阅读并同意本协议且完成全部激活程序后，或您以其他天信意健险作业端允许的方式实际使用IIAS公估理服务时，您即受本协议的约束。您可以使用您提供或确认的邮箱、手机号码或者天信意健险作业端允许的其它方式作为登录手段进入天信意健险作业端。 ",
							"(2)您了解并同意，如您系在本网站完成的注册程序，只要您注册成功，您即可以获得您的天信意健险作业端登录名。同时，您可以通过您的支付宝登录名或其他银联卡关联账户直接登录支付宝或相关银联卡结算页面并完成相关付款程序。您在此明确授权，您在本网站进行结算时，本网站您的结算信息交由支付宝及银联系统进行处理，您可以充分接受并严格按照支付宝及银联系统规则进行操作，在本网站跳转交易结算页面后，即说明您已充分知晓前产生的任何直接或间接损失及不利后果。",
							"(3)您可以对账户设置昵称，但您设置的昵称不得侵犯或涉嫌侵犯他人合法权益。如您设置的昵称涉嫌侵犯他人合法权益，天信意健险作业端有权终止向您提供服务，并注销您的账户。账户注销后，相应的昵称将开放给其他有权用户登记使用。",
							"(4)在完成注册或激活流程时，您应当按照法律法规要求，按相应页面的提示准确提供并及时更新您及您的爱车资料，以使之真实、及时，完整和准确。如有合理理由怀疑您提供的任何资料错误、不实、过时或不完整的，天信意健险作业端有权向您发出询问及/或要求改正的通知，并有权直接做出删除相应资料的处理，直至中止、终止对您提供部分或全部天信意健险作业端服务，天信意健险作业端对此不承担任何责任，您将承担因此产生的任何直接或间接损失及不利后果。述信息并同时接受支付宝及银联系统的规则约束及相关支付服务，天信意健险作业端对此不承担任何责任，您将承担因此产生的任何直接或间接损失及不利后果。"
						]
					},
					{
						title: "三、账户安全",
						text: [
							"您须自行负责对您的天信意健险作业端、支付宝及相关银联账户、登录名、昵称和密码的保密，且须对该账户、登录名、昵称和密码下发生的所有活动(包括但不限于信息披露、发布信息、网上点击同意或提交各类规则协议、网上续签协议或购买服务等)承担责任。您同意：",
							"(1)如发现任何人未经授权使用您的天信意健险作业端登录名、昵称 和密码，或发生违反保密规定的任何其他情况，您会立 即通知天信意健险作业端，并授权天信意健险作业端将该信息同步给其他关联 服务商(如支付宝、银联等)；",
							"(2)确保您在每个上网时段结束时，以正确步骤离开网站。天信意健险作业端不能也不会对因您未能遵守本款规定而发生的任何损失或损毁负责。您理解天信意健险作业端对您的请求采取行动需要合理时间，天信意健险作业端对在采取行动前已经产生的后果(包括但不限于您的任何损失)不承担任何责任。除非有法律规定或司法裁定，且征得天信意健险作业端的同意，否则，您的天信意健险作业端登录名、昵称和密码不得以任何方式转让、赠与或继承(与账户相关的财产权益除外)。"
						]
					},
					{
						title: "四、服务终止",
						text: [
							"4.1您同意，在天信意健险作业端未向您收取任何服务费的情况下，天信意健险作业端可自行全权决定以任何理由（包括但不限于天信意健险作业端认为您已违反本协议的字面意义和精神，或您以不符合本协议的字面意义和精神的方式行事）终止您的“服务”密码、账户（或其任何部份）或您对“服务”的使用（退还该账户剩余全部费用）。您同意，在天信意健险作业端向您收费的情况下，天信意健险作业端应基于合理的怀疑且经电子邮件或其他合理方式通知的情况下实施上述终止服务的行为。您进一步承认和同意，天信意健险作业端根据本协议规定终止您服务的情况下可立即使您的账户无效，或注销您的账户以及在您的账户内的所有相关资料和档案，和/或禁止您进一步接入该等档案或“服务”。账户终止后，天信意健险作业端没有义务为您保留原账户中或与之相关的任何信息，或转发任何未曾阅读或发送的信息给您或第三方。此外，您同意，天信意健险作业端不会就终止向您提供“服务”而对您或任何第三者承担任何责任。",
							"4.2您有权向天信意健险作业端要求注销您的账户，经天信意健险作业端审核同意的，天信意健险作业端将注销您的账户，届时，您与天信意健险作业端基于协议的合同关系即终止。您的账户被注销后，天信意健险作业端没有义务为您保留或向您披露您账户中的任何信息，也没有义务向您或第三方转发任何您未曾阅读或发送过的信息。",
							"4.3您理解并同意，您与天信意健险作业端的合同关系终止后：天信意健险作业端有权继续保存您的资料。您在使用服务期间存在违法行为或违反本协议和/或规则的行为的，天信意健险作业端仍可依据本协议向您主张权利。您在使用服务期间因使用服务与其他用户之间发生的关系，不因本协议的终止而终止，其他用户仍有权向您主张权利，您应继续按您的承诺履行义务。"
						]
					},
					{
						title: "五、关于费用",
						text: [
							"天信意健险作业端保留在根据第一条第3款通知您后，收取“服务”费用的权利。另外，您因进行交易、向天信意健险作业端获取有偿服务或接触天信意健险作业端服务器而发生的所有应纳税赋，以及相关硬件、软件、通讯、网络服务及其他方面的费用均由您自行承担。天信意健险作业端保留在无须发出书面通知，仅在网站公示的情况下，暂时或永久地更改或停止部分或全部“服务”的权利。您通过天信意健险作业端平台享受到4S店店端服务后，有权利要求4S店店端按照您在天信意健险作业端平台已实际支付的金额开具适格发票，相关税收标准按国家相关规定执行，与天信意健险作业端平台无关。"
						]
					},
					{
						title: "六、天信意健险作业端平台服务和地位",
						text: [
							"6.1通过天信意健险作业端提供的平台服务，您可在天信意健险作业端网站上寻找4S店店端发布的汽车保养/维修/二手车/汽车保险/事故车处理等综合类汽车后市场信息(以下简称“店端信息”)、达成交易意向并进行交易、对4S店店端服务进行评价、参加天信意健险作业端组织的活动以及使用其它信息服务及技术服务。",
							"6.2天信意健险作业端网站仅作为用户物色4S店店端信息，选定后就前述信息进行交易并获取与前述信息相关的各类服务的地点。同时，天信意健险作业端不涉及用户间因交易而产生的法律关系及法律纠纷，不会且不能牵涉进交易各方的交易当中。敬请注意，天信意健险作业端不能控制或保证4S店店端信息的真实性、合法性、准确性，亦不能控制或保证交易所涉及的产品及服务的质量、安全或合法性，以及相关交易各方在履行协议项下的各项义务的能力。天信意健险作业端不能也不会控制交易各方能否履行协议义务。天信意健险作业端希望您在使用天信意健险作业端网站时，小心谨慎并运用常识。"
						]
					},
					{
						title: "七、服务使用规范",
						text: [
							"7.1关于您的资料的规则",
							"“您的资料”包括您在注册、发布信息或交易等过程中、在任何公开信息场合或通过任何电子邮件形式，向天信意健险作业端或其他用户提供的任何资料，包括数据、文本、软件、音乐、声响、照片、图画、影像、词句或其他材料。您应对“您的资料”负全部责任，而天信意健险作业端仅作为您在网上发布和刊登“您的资料”的被动渠道。",
							"您同意并承诺，“您的资料”中：",
							"不会有欺诈成份；",
							"不会侵犯任何第三者的商标、商业秘密或其他知识产权，或隐私权、名誉权；",
							"不会违反任何法律、法规、条例或规章、本协议及相关规则；",
							"不会含有诽谤(包括商业诽谤)、非法恐吓或非法骚扰的内容；",
							"不会含有淫秽、或包含任何儿童色情内容；",
							"不会含有蓄意毁坏、恶意干扰、秘密地截取或侵占任何系统、数据或个人资料的任何病毒、伪装破坏程序、电脑蠕虫、定时程序炸弹或其他电脑程序；",
							"会直接或间接与下述各项货物或服务连接，或包含对下述各项货物或服务的描述：(i)本协议项下禁止的货物或服务；或(ii)您无权连接或包含的货物或服务。此外，您同意不会：(ii)在与任何连锁信件、大量胡乱邮寄的电子邮件、滥发电子邮件或任何复制或多余的信息有关的方面使用“服务”；(iv)未经其他人士同意，利用“服务”收集其他人士的电子邮件地址及其他资料；或(v)利用“服务”制作虚假的电子邮件地址，或以其他形式试图在发送人的身份或信息的来源方面误导其他人士；不含有天信意健险作业端认为应禁止或不适合通过天信意健险作业端网站宣传或交易。",
							"您同意，您不会对任何资料作商业性利用，包括但不限于在未经天信意健险作业端事先书面批准的情况下，复制在天信意健险作业端网站上展示的任何资料并用于商业用途。",
							"7.2违反规则的后果",
							"(1)倘若天信意健险作业端认为“您的资料”可能使天信意健险作业端承担任何法律或道义上的责任，或可能使天信意健险作业端(全部或部分地)失去天信意健险作业端的互联网服务供应商或其他供应商的服务，则天信意健险作业端可自行全权决定对“您的资料”采取天信意健险作业端认为必要或适当的任何行动，包括但不限于删除该类资料。您特此保证，您对提交给天信意健险作业端的“您的资料”拥有全部权利，包括全部版权。您确认，天信意健险作业端没有责任去认定或决定您提交给天信意健险作业端的资料哪些是应当受到保护的，对享有“服务”的其他用户使用“您的资料”，天信意健险作业端也不必负责。",
							"(2)对于您涉嫌违反承诺的行为对任意第三方造成损害的，您均应当以自己的名义独立承担所有的法律责任，并应确保天信意健险作业端免责。",
							
							"(3)在不限制其他补救措施的前提下，发生下述任一情况，天信意健险作业端可立即发出警告，暂时中止、永久中止或终止您的会员资格，删除您的任何现有产品信息，以及您在网站上展示的任何其他资料：(i)您违反本协议；(ii)天信意健险作业端无法核实或鉴定您向天信意健险作业端提供的任何资料；或(iii)天信意健险作业端相信您的行为可能会使您、天信意健险作业端其他用户或4S店店端或通过天信意健险作业端或天信意健险作业端网站提供服务的第三者服务供应商发生任何法律责任。在不限制任何其他补救措施的前提下，若发现您从事涉及天信意健险作业端网站的诈骗活动，天信意健险作业端可暂停或终止您的账户。",
							"(4)经生效法律文书确认用户存在违法或违反本协议行为或者天信意健险作业端自行判断用户涉嫌存在违法或违反本协议行为的，天信意健险作业端有权在天信意健险作业端上以网络发布形式公布用户的违法行为并做出处罚（包括但不限于限权、终止服务等）。"
						]
					},
					{
						title: "八、您授予的许可使用",
						text: [
							"您完全理解并同意不可撤销地授予天信意健险作业端及其关联公司下列权利：",
							"(1)对于您提供的资料，您授予天信意健险作业端及其关联公司独家的、全球通用的、永久的、免费的许可使用权利(并有权在多个层面对该权利进行再授权)，使天信意健险作业端及其关联公司有权(全部或部份地）使用、复制、修订、改写、发布、翻译、分发、执行和展示“您的资料”或制作其派生作品，和/或以现在已知或日后开发的任何形式、媒体或技术，将“您的资料”纳入其他作品内。",
							"(2)当您违反本协议或与天信意健险作业端签订的其他协议的约定，天信意健险作业端有权以任何方式通知关联公司，要求其对您的权益采取限制措施包括但不限于要求将您账户内的款项支付给天信意健险作业端指定的对象，要求关联公司中止、终止对您提供部分或全部服务，且在其经营或实际控制的任何网站公示您的违约情况。",
							"(3)同样，当您向天信意健险作业端关联公司作出任何形式的承诺，且相关公司已确认您违反了该承诺，则天信意健险作业端有权立即按您的承诺约定的方式对您的账户采取限制措施，包括但不限于中止或终止向您提供服务，并公示相关公司确认的您的违约情况。您了解并同意，天信意健险作业端无须就相关确认与您核对事实，或另行征得您的同意，且天信意健险作业端无须就此限制措施或公示行为向您承担任何的责任。",
						]
					},
					{
						title: "九、隐私",
						text: [
							"尽管有第九条所规定的许可使用权，但基于保护您的隐私是天信意健险作业端的一项基本原则，为此天信意健险作业端还将根据天信意健险作业端的隐私声明使用“您的资料”。天信意健险作业端隐私声明的全部条款属于本协议的一部份，因此，您必须仔细阅读。请注意，您一旦自愿地在天信意健险作业端交易地点披露”您的资料”，该等资料即可能被其他人士获取和使用。"
						]
					},
					{
						title: "十、责任范围和责任限制",
						text: [
							"(1)您明确理解和同意，天信意健险作业端不对因下述任一情况而发生的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其他无形损失的损害赔偿（无论天信意健险作业端是否已被告知该等损害赔偿的可能性）：(i)使用或未能使用“服务”；(ii)因通过或从“服务”购买或获取任何货物、样品、数据、资料或服务，或通过或从“服务”接收任何信息或缔结任何交易所产生的获取替代货物和服务的费用；(iii)未经批准接入或更改您的传输资料或数据；(iv)任何第者对“服务”的声明或关于“服务”的行为；或(v)因任何原因而引起的与“服务”有关的任何其他事宜，包括疏忽。",
							"(2)天信意健险作业端会尽一切努力使您在使用天信意健险作业端网站的过程中得到乐趣。遗憾的是，天信意健险作业端不能随时预见到任何技术上的问题或其他困难。该等困难可能会导致数据损失或其他服务中断。为此，您明确理解和同意，您使用“服务”的风险由您自行承担，且“服务”以“按现状”和“按可得到”的状态提供。天信意健险作业端明确声明不作任何种类的明示或暗示的保证，包括但不限于关于适销性、适用于某一特定用途和无侵权行为等方面的保证。天信意健险作业端对下述内容不作保证：(i)“服务”会符合您的要求；(ii)“服务”不会中断，且适时、安全和不带任何错误；(ii)通过使用“服务”而可能获取的结果将是准确或可信赖的；及(iv)您通过“服务”而购买或获取的任何产品、服务、资料或其他材料的质量将符合您的预期。通过使用“服务”而下载或以其他形式获取任何材料是由您自行全权决定进行的，且与此有关的风险由您自行承担，对于因您下载任何该等材料而发生的您的电脑系统的任何损毁或任何数据损失，您将自行承担责任。您从天信意健险作业端或通过或从“服务”获取的任何口头或书面意见或资料，均不产生未在本协议内明确载明的任何保证责任。"
						]
					},
					{
						title: "十一、赔偿",
						text: [
							"您同意，如因您违反本协议或经在此提及而纳入本协议的其他文件，或因您违反法律侵害了第三方的合法权利，或因您违反法律须承担行政或刑事责任，而使第三方或行政、司法机关对天信意健险作业端及其子公司、关联公司、分公司、董事、职员、代理人提出索赔或处罚要求(包括司法费用和其他专业人士的费用)，您必须全额赔偿给天信意健险作业端及其子公司、关联公司、分公司、董事、职员、代理人，并使其等免遭损失。",
						]
					},
					{
						title: "十二、链接“服务”或第三者均可提供与其他万维网网站或资源的链接。",
						text: [
							"由于天信意健险作业端并不控制该等网站和资源，您承认并同意，天信意健险作业端并不对该等外在网站或资源的可用性负责，且不认可该等网站或资源上或可从该等网站或资源获取的任何内容、宣传、产品、服务或其他材料，也不对其等负责或承担任何责任。您进一步承认和同意，对于任何因使用或信赖从此类网站或资源上获取的此类内容、宣传、产品、服务或其他材料而造成(或声称造成)的任何直接或间接损失，天信意健险作业端均不承担责任。"
						]
					},
					{
						title: "十三、通知",
						text: [
							"您应当准确填写并及时更新您提供的电子邮件地址、联系电话、联系地址、邮政编码等联系方式，以便天信意健险作业端或其他用户与您进行有效联系，因通过这些联系方式无法与您取得联系，导致您在使用天信意健险作业端服务过程中产生任何损失或增加费用的，应由您完全独自承担。您了解并同意，您有义务保持你提供的联系方式的有效性，如有变更需要更新的，您应按天信意健险作业端的要求进行操作。除非另有明确规定，任何您与天信意健险作业端之间的通知应以电子邮件形式发送，(就天信意健险作业端而言)电子邮件地址为czws2019@126.com,或(就您而言)发送到您在登记注册过程中向天信意健险作业端提供的电子邮件地址，或有关方指明的该等其他地址。在电子邮件发出二十四(24)小时后，通知应被视为已送达，除非发送人被告知相关电子邮件地址已作废。或者，天信意健险作业端可通过邮资预付挂号邮件并要求回执的方式，将通知发到您在登记过程中向天信意健险作业端提供的地址。在该情况下，在付邮当日三3天后通知被视为已送达。"
						]
					},
					{
						title: "十四、不可抗力因素",
						text: [
							"因天信意健险作业端合理控制范围以外的原因，包括但不限于自然灾害、罢工或骚乱、物质短缺或定量配给、暴动、战争行为、政府行为、通讯或其他设施故障或严重伤亡事故等，致使天信意健险作业端延迟或未能履约的，天信意健险作业端不对您承担任何责任。"
						]
					},
					{
						title: "十五、法律适用、管辖及其他",
						text: [
							"(1)本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国大陆地区法律，如无相关法律规定的，则应参照通用国际商业惯例和（或）行业惯例。",
							"(2)您与天信意健险作业端仅为独立订约人关系。本协议无意结成或创设任何代理、合伙、合营、雇佣与被雇佣或特性授权与被授权关系。",
							"(3)您同意天信意健险作业端因经营业务需要有权将本协议项下的权力义务就部分或全部进行转让，而无须再通知予您并取得您的同意。",
							"(4)因本协议或天信意健险作业端服务所引起或与其有关的任何争议应向天信意健险作业端所在地人民法院提起诉讼。",
							"(5)本协议取代您和天信意健险作业端先前就相同事项订立的任何书面或口头协议。倘若本协议任何条款被裁定为无效或不可强制执行，该项条款应被撤销，而其余条款应予遵守和执行。条款标题仅为方便参阅而设，并不以任何方式界定、限制、解释或描述该条款的范围或限度。天信意健险作业端未就您或其他人士的某项违约行为采取行动，并不表明天信意健险作业端撤回就任何继后或类似的违约事件采取动的权利。"
						]
					}
				]
			};
		}
	}
</script>

<style>
.userAgreement{
	padding: 20px 30px;
	border-top: 1px solid #cccccc;
	font-size: 16px;
	line-height: 48px;
	color: #444444;
}
.userAgreement .userAgreement-tit{
	display: block;
	font-size: 20px;
	color: #222222;
	text-align: center;
	font-weight: 500;
}
/* 段落 */
.userAgreement .dl{
	display: block;
	text-indent: 2em;
}
.userAgreement .txt-box{
	padding: 30px 0 20px;
	border-bottom: 1px solid #eeeeee;
}
.userAgreement .txt-box.qy{
	padding: 10px 0 20px;
}
.userAgreement .txt-box .tit{
	font-size: 20px;
	font-weight: 500;
	color: #222222;
	display: block;
	margin-bottom: 10px;
}
.userAgreement .txt-box text{
	display: block;
}
</style>

